module.exports = __webpack_public_path__ + "img/login_bg.bf7ad0ce.png";